import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/auth/use_auth'
import { useUnreadNotifications } from '../../providers/unread_notifications_provider'
import NotificationPopup from '../notifications/notification_popup'

const Header: React.FC = () => {
  const navigate = useNavigate()
  const { user, logout } = useAuth()
  const { unreadCount, unreadMessages } = useUnreadNotifications()
  const [showNotificationPopup, setShowNotificationPopup] = useState(false)

  if (user === null) {
    return null
  }

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  return (
    <header className="py-6">
      <div className="flex items-center justify-end gap-4 w-11/12 mx-auto">
        <div
          className="flex items-center gap-2 pr-4 cursor-pointer hover:opacity-50 transition-opacity duration-300"
          onClick={() =>
            navigate(`/enterprises/detail/${user.kuchikomiEnterpriseId}`)
          }
        >
          <img src={user.iconUrl} className="h-6 rounded-sm hover:opacity-50" />
          <span className="text-sm font-semibold">{user.displayName}</span>
        </div>
        <div
          className="relative cursor-pointer"
          onClick={() => navigate('/enterprises/search')}
        >
          <span className="material-icons !text-xl hover:opacity-50 transition-opacity duration-300">
            search
          </span>
        </div>
        <div
          className="relative cursor-pointer"
          onClick={() => setShowNotificationPopup(!showNotificationPopup)}
        >
          <span className="material-icons !text-xl hover:opacity-50 transition-opacity duration-300">
            notifications
          </span>
          {unreadCount > 0 && (
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-main-red rounded-full"></span>
          )}
          {showNotificationPopup && (
            <NotificationPopup
              unreadMessages={unreadMessages}
              onClose={() => setShowNotificationPopup(false)}
            />
          )}
        </div>
        <div
          className="relative cursor-pointer"
          onClick={() => navigate('/chat')}
        >
          <span className="material-icons !text-xl hover:opacity-50 transition-opacity duration-300">
            chat
          </span>
          {unreadCount > 0 && (
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-main-red rounded-full"></span>
          )}
        </div>
        <div className="relative cursor-pointer" onClick={handleLogout}>
          <span className="material-icons !text-xl hover:opacity-50 transition-opacity duration-300">
            logout
          </span>
        </div>
      </div>
    </header>
  )
}

export default Header
